import React from 'react';
import ReactDOM from 'react-dom';
import { default as RefineResultModalHeader } from './RefineResultModalHeader';
import { default as RefineResultActiveFilters } from './RefineResultActiveFilters';
import { getTranslation } from '../../lang/main';

const modalRoot = document.getElementById('modal-root');

class RefineResultsModal extends React.Component {
    constructor(props) {
        super(props);

        const { modalKey } = this.props;

        this.el = document.createElement('div');
        this.el.setAttribute('id', modalKey);
        this.el.setAttribute('role', 'dialog');
        this.el.setAttribute('class', 'modal modal--small fade');
    }

    componentDidMount() {
        modalRoot.appendChild(this.el);
    }

    componentWillUnmount() {
        modalRoot.removeChild(this.el);
    }

    render() {
        const {
            activeFilters,
            clearFilter,
            clearAllFilters,
            ignoreDisplayingFilters,
        } = this.props;

        return ReactDOM.createPortal(
            <div className='modal__center'>
                <div className='modal-dialog modal__helper'>
                    <div className='modal__container' style={{ maxWidth: 470 }}>
                        <RefineResultModalHeader
                            title={getTranslation('REFINE_RESULTS')}
                        />

                        <div className='modal__content'>
                            <RefineResultActiveFilters
                                activeFilters={activeFilters}
                                clearFilter={clearFilter}
                                clearAllFilters={clearAllFilters}
                                ignoreDisplayingFilters={
                                    ignoreDisplayingFilters
                                }
                            />

                            {this.props.children}
                        </div>
                    </div>
                </div>
            </div>,
            this.el
        );
    }
}

export default RefineResultsModal;
